import dayjs, { ConfigType, Dayjs } from 'dayjs'

import { ISO_EXTENDED } from '../../constants/formats'
import { dateArrayType } from '../../constants/types'
import { FormData } from '../../hooks/useForm'

export type ValidationFunction = (value: string | string[]) => boolean

export const email: ValidationFunction = (value) => {
  if (typeof value === 'string') {
    return /^[A-Z0-9a-z'!?#$&*/^`{}|=._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$/.test(
      value,
    )
  } else {
    return true
  }
}

export const equals = (original: string): ValidationFunction => {
  return (value) => {
    if (value === null) {
      return false
    }
    return value === original
  }
}

export const maxLength = (max: number): ValidationFunction => {
  return (value) => {
    if (value === null) {
      return false
    }
    return value.length <= max
  }
}

export const maxNumber = (max: number): ValidationFunction => {
  return (value) => {
    if (value === null) {
      return false
    }

    if (typeof value === 'string' && value.trim() === '') {
      return false
    }

    const valueAsNumber = Number(value)

    return !isNaN(valueAsNumber) && valueAsNumber <= max
  }
}

export const minLength = (min: number): ValidationFunction => {
  return (value) => {
    if (value === null) {
      return false
    }
    return value.length >= min
  }
}

export const minDate = (minDate: Dayjs): ValidationFunction => {
  return (value) => {
    if (value === null) {
      return false
    }

    let theValue: ConfigType
    if (Array.isArray(value)) {
      // This is hacky as hell, but trying it to see if it'll fulfill dayjs's array contract
      const arrLength = Math.min(value.length, 7)

      theValue = Array<number>(7) as dateArrayType

      for (let i = 0; i < arrLength; i++) {
        theValue[i] = parseInt(value[i], 10)
      }
    } else {
      theValue = value
    }

    const d = dayjs(theValue, ISO_EXTENDED, true)

    if (!d.isValid()) {
      return false
    }

    return !d.isBefore(minDate)
  }
}

export const minNumber = (min: number): ValidationFunction => {
  return (value) => {
    if (value === null) {
      return false
    }

    if (typeof value === 'string' && value.trim() === '') {
      return false
    }

    const valueAsNumber = Number(value)

    return !isNaN(valueAsNumber) && valueAsNumber >= min
  }
}

export const match = (key: string, formData: FormData): ValidationFunction => {
  return (value) => {
    if (value === null) {
      return false
    }
    return value === formData[key]
  }
}

export const regExp =
  (reg: RegExp): ValidationFunction =>
  (value) =>
    value && typeof value === 'string' ? reg.test(value) : false

export const boolean = (value: string) => value === 'true'
